var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldNum = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.167
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.832 2.625h6.417M5.832 5.542h6.417M5.832 8.458h6.417M5.832 11.375h6.417M1.75 8.458H3.5v.875l-1.75 1.75v.292H3.5M2.04 3.208l.582-.583v2.917m0 0H2.04m.583 0h.584"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldNum);
export default ForwardRef;